<div class="ag-theme-alpine" style="width: 100%;">
  <ag-grid-angular class="ag-theme-alpine compact-centered" style=" width:100%;" [rowData]="rows" [columnDefs]="columns"
    [defaultColDef]="defaultColDef" [processUnpinnedColumns]="processUnpinnedColumns" [gridOptions]="gridOptions"
    domLayout="autoHeight">
  </ag-grid-angular>
</div>
<!-- [defaultColDef]="defaultColDef"
  [getRowId]="getRowId"
  [theme]="'legacy'" -->